
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import axiosInstance from '../axiosConfig';
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import '../styles.css';

const ArTransactions = () => {
  const [userData, setUserData] = useState(null);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all'); 
  const [approver, setApprover] = useState({});
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isIdCardPopupVisible, setIsIdCardPopupVisible] = useState(false);

  const currentUserId = localStorage.getItem('id');

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 520) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => setUserData(response.data))
        .catch((error) => console.error('Error fetching user data:', error));
    }
  }, [currentUserId]);

  useEffect(() => {
    axiosInstance.get(`/assign-manager/${currentUserId}/`)
      .then((response) => setApprover(response.data))
      .catch((error) => console.error('Error fetching approver data:', error));
  }, [currentUserId]);

  useEffect(() => {
    fetchAttendanceRequests();
  }, [filterStatus]);

  const fetchAttendanceRequests = () => {
    let url = 'attendance/regularize/search/';
    if (filterStatus !== 'all') {
      url += `?status=${filterStatus}`;
    }
    
    axiosInstance.get(url)
      .then((response) => {
        setAttendanceData(response.data.attendance_requests); 
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching attendance data:', error);
        setLoading(false);
      });
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  const menuItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/user-dashboard' },
    { icon: '&#128100;', label: 'My Profile', path: `/user-profile/${userData?.id}` },
    { icon: '&#128197;', label: 'Attendance', path: `/leave-attendance/${userData?.id}` },
    { icon: '&#128203;', label: 'Leave Management', path: `/leave-management/${userData?.id}` },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar', condition: userData?.role_name === 'employee' },
    { icon: '&#9998;', label: 'Create AR Request', path: `/ar-request/${userData?.id}` },
    { icon: '&#128200;', label: 'My Calendar', path: '/my-calendar' },
    { icon: '&#128202;', label: 'AR Transactions', path: '/ar-transaction/' },
    // { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
    { icon: '&#128179;', label: 'ID Card', action: () => setIsIdCardPopupVisible(true) },
  ];

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return 'status-badge-approved';
      case 'pending':
        return 'status-badge-pending';
      case 'rejected':
        return 'status-badge-rejected';
      case 'cancelled':
        return 'status-badge-cancelled';
      default:
        return 'status-badge-default';
    }
  };

  const profilePhotoUrl = userData?.profile_photo?.startsWith('http://') 
    ? userData?.profile_photo.replace('http://', 'https://') 
    : userData?.profile_photo;

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header 
        onToggleClick={handleToggleClick} 
        isSidebarVisible={isSidebarVisible} 
      />
      
      <Sidebar 
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />
      
      <div className="dashboard-main-content">
        <div className="ar-transactions-container">
          <div className="ar-transactions-header">
            <div className="header-left-section">
              <h1>Attendance Requests</h1>
              <p>View and manage your attendance regularization requests</p>
            </div>
            <div className="header-right-section">
              <div className="filter-dropdown">
                <select 
                  value={filterStatus} 
                  onChange={(e) => setFilterStatus(e.target.value)}
                  className="status-filter-select"
                >
                  <option value="all">All Requests</option>
                  <option value="approved">Approved</option>
                  <option value="pending">Pending</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading attendance requests...</p>
            </div>
          ) : (
            <div className="ar-transactions-card">
              {attendanceData.length > 0 ? (
                <div className="table-responsive">
                  <table className="ar-transactions-table">
                    <thead>
                      <tr>
                        <th>Request Date</th>
                        <th>Attendance Dates</th>
                        <th>Reason</th>
                        <th>Approver</th>
                        <th>Updated</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {attendanceData.map((attendanceRecord, index) => (
                        <tr key={attendanceRecord.id}>
                          <td>
                            <div className="date-cell">
                              <span className="date-icon">📅</span>
                              {new Date(attendanceRecord.created_at).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                              })}
                            </div>
                          </td>
                          <td>
                            <div className="attendance-dates">
                              <div className="date-row">
                                <span className="in-label">In:</span>
                                <span className="date-value">{attendanceRecord.in_date} {attendanceRecord.in_time}</span>
                              </div>
                              <div className="date-row">
                                <span className="out-label">Out:</span>
                                <span className="date-value">{attendanceRecord.out_date} {attendanceRecord.out_time}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="reason-cell" title={attendanceRecord.reason}>
                              {attendanceRecord.reason.length > 50 
                                ? attendanceRecord.reason.substring(0, 50) + '...' 
                                : attendanceRecord.reason}
                            </div>
                          </td>
                          <td>
                            <div className="approver-cell">
                              <span className="approver-icon">👤</span>
                              {approver.manager_name || 'N/A'}
                            </div>
                          </td>
                          <td>
                            <div className="updated-cell">
                              {new Date(attendanceRecord.updated_at).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric'
                              })}
                            </div>
                          </td>
                          <td>
                            <span className={`status-badge ${getStatusBadgeClass(attendanceRecord.status)}`}>
                              {attendanceRecord.status}
                            </span>
                          </td>
                          <td>
                            <Link 
                              to={`/ar-details/${attendanceRecord.id}`} 
                              className="action-link"
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon">📋</div>
                  <h3>No Attendance Requests Found</h3>
                  <p>There are no attendance regularization requests to display.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      {/* ID Card Popup */}
      {isIdCardPopupVisible && (
        <div className="id-card-overlay" onClick={() => setIsIdCardPopupVisible(false)}>
          <div className="id-card-popup" onClick={(e) => e.stopPropagation()}>
            <button className="id-card-close" onClick={() => setIsIdCardPopupVisible(false)}>×</button>
            
            <div className="id-card-header">
              <img src="/Teamhalt.png" alt="Logo" className="id-card-logo" />
              <span>TEAMHALT PRIVATE LIMITED</span>
            </div>
            
            <div className="id-card-body">
              <div className="Id-card-profile">
                <img
                  src={profilePhotoUrl || '/profile.jpg'}
                  alt="Profile"
                  className="id-card-photo"
                />
                <div className="id-card-info">
                  <h4>{userData?.first_name} {userData?.last_name}</h4>
                  <p className="id-designation">{userData?.designation}</p>
                  <div className="id-dob">
                    <strong>DOB:</strong>
                    <span>
                      {userData?.date_of_birth
                        ? new Date(userData.date_of_birth).toLocaleDateString("en-GB").replace(/\//g, "-")
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
              
              <hr className="id-card-divider" />
              
              <div className="Id-card-details">
                {[
                  { label: "Emp ID", value: userData?.employee_code },
                  { label: "Department", value: userData?.department },
                  { label: "ESIC No.", value: userData?.esic_no },
                  { label: "UAN No.", value: userData?.uan_no },
                  { label: "Gender", value: userData?.gender },
                  { label: "Contact No.", value: userData?.contact_number },
                ].map((item, idx) => (
                  <div key={idx} className="detail-row">
                    <strong>{item.label}:</strong>
                    <span>{item.value || "N/A"}</span>
                  </div>
                ))}
              </div>
              
              {typeof userData?.work_location_name === "string" &&
                userData.work_location_name.toLowerCase() !== "noida" && (
                <div className="id-card-duty">
                  <strong>On Contractual Duty Of:</strong>
                  <span>{userData?.duty_of || "N/A"}</span>
                </div>
              )}
              
              <div className="id-card-footer">
                https://teamhalt.com/
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArTransactions;


